import styled from "styled-components";

const ExternalLink = styled.a.attrs(() => ({
  rel: "noopener",
}))`
  text-decoration: none;
`;

export default ExternalLink;
